var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4697 10.5303L11.4697 13.5303C11.7626 13.8232 12.2374 13.8232 12.5303 13.5303L15.5303 10.5303C15.8232 10.2374 15.8232 9.7626 15.5303 9.4697C15.2374 9.1768 14.7626 9.1768 14.4697 9.4697L12.75 11.1893V1C12.75 0.58579 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.58579 11.25 1V11.1893L9.5303 9.4697C9.2374 9.1768 8.7626 9.1768 8.4697 9.4697C8.1768 9.7626 8.1768 10.2374 8.4697 10.5303ZM4.53033 0.46967C4.23744 0.17678 3.76256 0.17678 3.46967 0.46967L0.469668 3.46967C0.176777 3.76256 0.176777 4.23744 0.469668 4.53033C0.762558 4.82322 1.23744 4.82322 1.53033 4.53033L3.25 2.81066V13C3.25 13.4142 3.58579 13.75 4 13.75C4.41421 13.75 4.75 13.4142 4.75 13V2.81066L6.4697 4.53033C6.7626 4.82322 7.2374 4.82322 7.5303 4.53033C7.8232 4.23744 7.8232 3.76256 7.5303 3.46967L4.53033 0.46967Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sortingIcon.ae081ed1e87a605a0c02cebf4966eb88.svg";
export { ForwardRef as ReactComponent };